import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const TASK_CENTER_PERMISSIONS = {
  READ: 'task_center:read',
  CREATE: 'task_center:create',
  ASSIGN: 'task_center:assign',
  TRANSITION: 'task_center:transition',
} as const;

export function canSeeTaskCenterMenu(permissions: readonly string[]): boolean {
  return hasPermission(permissions, TASK_CENTER_PERMISSIONS.READ);
}
